// extracted by mini-css-extract-plugin
export var header = "_gb-0";